<template>
    <pre>{{JSON.stringify(this.jsonData, undefined, 2)}}</pre>
</template>

<script>
import {maybeParseValue} from '../lib/helpers';

export default {
    props: {
        json: String
    },
    computed: {
        jsonData(){
            return maybeParseValue(this.json);
        }
    }
}
</script>

